/**
 * Where the household session stands for the current page load.
 *
 * A session token outlives a reload in local storage but the household it
 * belongs to does not, so there is a window on every load where the campaign
 * knows a participant is signed in yet has nothing to show them. "Not restored
 * yet" and "no session at all" are different answers and every gate has to be
 * able to tell them apart.
 */
export enum CharitySessionStatus {
  Restoring = "restoring",
  SignedIn = "signed_in",
  SignedOut = "signed_out",
}
